<!--
  @Description 高级查找组件（待完善）
  @Date 2021-12-23
  @Author liushuo
-->
<template>
  <div class="search-container">
    <!-- 输入框 -->
    <div class="input-dv">
      <!-- 动态选渲染查询条件 -->
      <el-form
        size="mini"
        ref="SearchFormRef"
        @keyup.enter.native="submitForm"
        :model="searchForm"
        :inline="true"
      >
        <el-form-item
          :index="Item.id + ''"
          v-for="(Item, index) in searchForm.Searchobject"
          :key="Item.id"
          :label="Item.label"
          :label-width="lableWidth(Item.label)"
          :prop="'Searchobject.' + index + '.value'"
        >
          <!-- 输入框 -->
          <el-input
            v-if="Item.type === 'TEXTBOX'"
            v-model="Item.value"
            :placeholder="placeholderConfig.input"
            @change="changeinput(Item)"
            :ref="`list${index}`"
          ></el-input>
          <!-- 时间选择 -->
          <el-date-picker
            v-if="Item.type === 'DATETIMEPICKER'"
            type="date"
            :placeholder="placeholderConfig.input"
            value-format="yyyy-MM-dd"
            v-model="Item.value"
            @change="changeinput(Item)"
            :ref="`list${index}`"
          ></el-date-picker>
          <!-- 年月选择框 -->
          <el-date-picker
            v-if="Item.type === 'Month'"
            type="month"
            value-format="yyyy-MM"
            :placeholder="placeholderConfig.input"
            v-model="Item.value"
            @change="changeinput(Item)"
            :ref="`list${index}`"
          ></el-date-picker>
          <!-- 下拉框 -->
          <el-select
            size="mini"
            clearable
            v-if="Item.type === 'COMBOBOX'"
            v-model="Item.value"
            :placeholder="placeholderConfig.select"
            @change="changeSelect(Item)"
            filterable
            :disabled="selectdisabled"
            :ref="`list${index}`"
          >
            <el-option
              :index="option.value + ''"
              v-for="option in Item.comboxItem"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></el-option>
          </el-select>
          <!-- 下拉框 多选 -->
          <el-select
            clearable
            v-if="Item.type === 'COMBOBOXMULTI'"
            v-model="Item.value"
            multiple
            :placeholder="placeholderConfig.select"
            collapse-tags
            filterable
            :disabled="selectdisabled"
            :ref="`list${index}`"
          >
            <el-option
              :index="option.value + ''"
              v-for="option in Item.comboxItem"
              :key="option.value"
              :label="option.text"
              :value="option"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 按钮 -->
    <div class="save-button-dv">
      <!-- type="primary" -->
      <el-button
        icon="el-icon-search"
        ref="btnSearch"
        size="mini"
        @click="search"
        >查询</el-button
      >
      <el-button
        type="info"
        icon="el-icon-refresh"
        size="mini"
        @click="resetSearchForm"
        >重置
      </el-button>

      <!-- <input
        ref="input"
        style="border: none"
        @keyup.enter="submitForm"
        class="hidden_class"
        type="text"
      /> -->
    </div>
  </div>
</template>

<script>
import { throttle } from 'lodash'

export default {
  props: {
    searchVuePath: {
      type: String,
      default: ''
    },
    menuArgs: {
      type: String,
      default: ''
    },
    menuArgsForCmb: {
      type: String,
      default: ''
    },
    fullSearchFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchForm: {
        Searchobject: []
      },
      contentStyleObj: {
        height: '100px'
      },
      selectdisabled: false,
      mainHeight: '80px',
      // 权限控制
      Authority: this.AuthorityFilter(this.$route.path)
    }
  },
  async mounted() {
    this.BindText()
    // const { data: res } = await this.$http.post('/vue-filter', {
    //   vuePath: this.searchVuePath,
    //   menuArgs: this.menuArgs,
    //   menuArgsForCmb: this.menuArgsForCmb
    // })
    // if (res.isSuccess) {
    //   this.searchForm.Searchobject = res.data
    //   if (this.Authority.alEffectCondition !== '审批') {
    //     this.searchForm.Searchobject = this.searchForm.Searchobject.filter(
    //       item => {
    //         return item.name !== 'ApproveState'
    //       }
    //     )
    //   }
    // }
  },
  methods: {
    async BindText() {
      const { data: res } = await this.$http.post('/vue-filter', {
        vuePath: this.searchVuePath,
        menuArgs: this.menuArgs,
        menuArgsForCmb: this.menuArgsForCmb
      })
      if (res.isSuccess) {
        this.searchForm.Searchobject = res.data
        if (this.Authority.alEffectCondition !== '审批') {
          this.searchForm.Searchobject = this.searchForm.Searchobject.filter(item => {
            return item.name !== 'ApproveState'
          })
        }
      }
    },
    submitForm() {
      let self = this
      // this.$refs.input.focus()
      self.search()
    },
    changeSelect(Item) {
      Item.comboxItem.forEach(element => {
        if (element.value === Item.value) {
          Item.text = element.text
        }
      })
      if (Item !== undefined) {
        this.selectdisabled = true
      }
      this.$nextTick(function () {
        // this.$refs.input.focus()
        this.selectdisabled = false
      })
    },
    async RefreshSearch() {
      this.BindText()
      // const { data: res } = await this.$http.post('/vue-filter', {
      //   vuePath: this.searchVuePath,
      //   menuArgs: this.menuArgs,
      //   menuArgsForCmb: this.menuArgsForCmb
      // })
      // if (res.isSuccess) {
      //   this.searchForm.Searchobject = res.data
      // }
    },
    search: throttle(function () {
      let searchObjects = []
      if (this.fullSearchFilter === true) {
        for (let item of this.searchForm.Searchobject) {
          if (item.text === null) {
            item.text = ''
          }
          if (item.value === null) {
            item.value = ''
          }
          let value = item.value
          let text = item.text
          if (Array.isArray(value)) {
            text = value
              .map(i => {
                return i.value
              })
              .toString()
            value = value
              .map(i => {
                return i.value
              })
              .toString()
          }
          searchObjects.push({
            id: item.id,
            label: item.label,
            tableAlias: item.tableAlias,
            name: item.name,
            type: item.type,
            operator: item.operator,
            text: text,
            value: value,
            comboxItem: item.comboxItem
          })
        }
      } else {
        this.searchForm.Searchobject.forEach(item => {
          if (item.text === null) {
            item.text = ''
          }
          if (item.value === null) {
            item.value = ''
          }
          if (Array.isArray(item.value)) {
            if (item.value.length > 0) {
              searchObjects.push({
                id: item.id,
                label: item.label,
                tableAlias: item.tableAlias,
                name: item.name,
                type: item.type,
                operator: item.operator,
                text: item.value
                  .map(i => {
                    return i.value
                  })
                  .toString(),
                value: item.value
                  .map(i => {
                    return i.value
                  })
                  .toString(),
                comboxItem: item.comboxItem
              })
            }
          } else if (item.value.replace(/(^\s*)|(\s*$)/g, '')) {
            searchObjects.push({
              id: item.id,
              label: item.label,
              tableAlias: item.tableAlias,
              name: item.name,
              type: item.type,
              operator: item.operator,
              text: item.text.replace(/(^\s*)|(\s*$)/g, ''),
              value: item.value.replace(/(^\s*)|(\s*$)/g, ''),
              comboxItem: item.comboxItem
            })
          }
        })
      }
      this.$emit('search', searchObjects)
    }, 1000, { leading: true, trailing: true }),
    resetSearchForm() {
      this.$refs.SearchFormRef.resetFields()
      this.searchForm.Searchobject.forEach(item => {
        item.text = ''
        item.value = ''
      })
    },
    lableWidth() {
      // if (label.length <= 4) {
      //   return '80px'
      // } else if (label.length > 8) {
      //   return '120px'
      // } else {
      //   return label.length * 20 + 'px'
      // }
      return '120px'
    },
    inputWidth(label) {
      if (label.length <= 4) {
        return '180px'
      } else if (label.length > 8) {
        return '140px'
      } else {
        return 260 - label.length * 20 + 'px'
      }
    },
    changeinput(item) {
      item.text = item.value
    },
    setHeight(height) {
      this.contentStyleObj.height = height + 'px'
      this.mainHeight = height - 40 + 'px'
    }
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
// 方案容器宽度
@plan-width: 200px;

/deep/ .el-date-editor {
  .el-input__inner {
    padding-right: 15px !important;
  }
}

/deep/ .el-input__inner {
  height: 24px !important;
}

.search-container {
  height: 100%;
  width: 100%;
  display: flex;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: #bebebe 2px 2px 10px;

  .input-dv {
    // box-sizing: border-box;
    // padding: 15px 0;
    width: calc(100% - @plan-width);
    height: 100%;
    overflow: auto;
    // background-color: #ebebeb;
    background-color: #f2f3f5;
    .fl;
  }

  .save-button-dv {
    width: @plan-width;
    height: 100%;
    background-color: #f2f3f5;
    .fl;
  }
}
</style>
